<template>
   <section class="homescreeninfo">

      <div class="page-refresh">
         <div class="page-refresh__trigger" @click="showBtn"></div>
            <button type="btn" value="Reload Page" @click="refresh" class="page-refresh__btn" v-bind:class="{ btnActive: reloadBtn }">
               <svg viewBox="-45 -17 533 533.33327" xmlns="http://www.w3.org/2000/svg"><path d="m202.1875 22.515625c-42.113281 0-84.203125 11.898437-121.726562 34.414063-20.507813 12.351562-39.230469 27.453124-55.636719 44.894531l1.890625-89.0625c.152344-6.898438-5.320313-12.617188-12.226563-12.761719h-.273437c-6.796875.00390625-12.34375 5.4375-12.488282 12.234375l-2.609374 122.621094c-1.820313 4.628906-.722657 9.894531 2.789062 13.414062 3.511719 3.515625 8.773438 4.621094 13.402344 2.804688l122.652344-2.609375c6.902343-.074219 12.441406-5.726563 12.367187-12.632813-.074219-6.898437-5.726563-12.441406-12.632813-12.367187h-.269531l-100.40625 2.132812c16.183594-18.585937 35.183594-34.527344 56.300781-47.238281 33.636719-20.1875 71.285157-30.851563 108.867188-30.851563 60.097656 0 115.511719 24.800782 156.039062 69.824219 36.132813 40.148438 57.699219 93.945313 57.699219 143.914063 0 49.972656-21.566406 103.769531-57.699219 143.917968-40.527343 45.03125-95.941406 69.832032-156.039062 69.832032-35.234375.242187-69.941406-8.578125-100.78125-25.625-28.304688-15.914063-52.71875-37.925782-71.472656-64.433594-3.945313-5.664062-11.738282-7.058594-17.402344-3.113281-5.664062 3.945312-7.0625 11.738281-3.117188 17.402343.054688.070313.105469.140626.152344.214844 20.929688 29.539063 48.15625 54.066406 79.722656 71.789063 34.542969 19.117187 73.421876 29.019531 112.898438 28.765625 67.28125 0 129.296875-27.734375 174.621094-78.101563 40.152344-44.613281 64.125-104.660156 64.125-160.636719 0-55.980468-23.96875-116.03125-64.125-160.644531-45.324219-50.363281-107.339844-78.097656-174.621094-78.097656zm0 0"/></svg>
            </button>
      </div>
	   
      <div class="homescreeninfo__slider">
         
         <flickity ref="flickity" :options="flickityHomeScreenInfo">
            <div class="carousel-cell carousel-cell__homescreeninfo">
               <div class="homescreeninfo__img" style="background: url('https://cdn.experienceoz.com.au/assets/images/home/homescreen-1.jpg') no-repeat center center;"></div>
            </div>
            <div class="carousel-cell carousel-cell__homescreeninfo">
               <div class="homescreeninfo__img" style="background: url('https://cdn.experienceoz.com.au/assets/images/home/homescreen-2.jpg') no-repeat center center;"></div>
            </div>
            <div class="carousel-cell carousel-cell__homescreeninfo">
               <div class="homescreeninfo__img" style="background: url('https://cdn.experienceoz.com.au/assets/images/home/homescreen-3.jpg') no-repeat center center;"></div>
            </div>
            <div class="carousel-cell carousel-cell__homescreeninfo">
               <div class="homescreeninfo__img" style="background: url('https://cdn.experienceoz.com.au/assets/images/home/homescreen-4.jpg') no-repeat center center;"></div>
            </div>
            <div class="carousel-cell carousel-cell__homescreeninfo">
               <div class="homescreeninfo__img" style="background: url('https://cdn.experienceoz.com.au/assets/images/home/homescreen-5.jpg') no-repeat center center;"></div>
            </div>
         </flickity>
      
      </div>
      <div class="container">
         <div class="homescreeninfo__title">
            <h1>Hola, <br/>G’day, Hi,<br/>Konnichiwa,<br />Bonjour</h1>
         </div>

         <div class="homescreeninfo__content">
            <p>Welcome to Crystalbrook Riley, your home away from home for the next little while.</p>
            <p>Splash into fun and discover all things that Cairns and Tropical North Queensland have to offer.</p>
            <p>Simply tap the screen to view a range of the best things to do in Cairns and book from your phone, the self-service kiosk, in-room Apple iPad or chat to our Lobby Ambassador and they will sort it out for you.</p>
         </div>
      </div>
   </section>
</template>

<script>
   import Flickity from 'vue-flickity';

   export default {
      name: 'HomeScreenInfo',
      props: ['screenId'],
      components: {
         Flickity
      },

      data() {
         return {
            flickityHomeScreenInfo: {
               fullscreen: true,
               prevNextButtons: false,
               pageDots: false,
               autoPlay: true,
               wrapAround: true,
            },
            reloadBtn: false
         }
      },

      methods: {
         next() {
            this.$refs.flickity.next();
         },

         previous() {
            this.$refs.flickity.previous();
         }, 

         showBtn() {
            this.reloadBtn = !this.reloadBtn;
         },
		  
		  refresh() {
			  this.$router.go()
		  }
      }
   }
</script>
